// ProductProvider.jsx
import { createContext, useContext, useEffect, useState } from 'react';
import { fetchProducts } from './strapi/queries'; 

const ProductContext = createContext();

export const ProductProvider = ({ children }) => {
  const [products, setProducts] = useState(null); // null = nicht geladen
  const [isLoading, setIsLoading] = useState(false);

  const loadProducts = async () => {
    const token = localStorage.getItem('jwt');
    if (!token) return;

    setIsLoading(true);
    try {
      
      const result = await fetchProducts();
      setProducts(result);
    } catch (error) {
      console.error('Fehler beim Laden der Produkte:', error);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    loadProducts(); // gleich laden, aber App blockiert nicht
  }, []);

  return (
    <ProductContext.Provider value={{ products, isLoading, reload: loadProducts }}>
      {children}
    </ProductContext.Provider>
  );
};

export const useProducts = () => {
  const context = useContext(ProductContext);
  if (!context) {
    throw new Error('useProducts muss innerhalb eines ProductProviders verwendet werden');
  }
  return context;
};
